import { CoachingGoalStatus } from "@/constants"

class Urls {
    private static api = "/api"

    private static coachCalendar = `${Urls.api}/coach-calendar`

    /* AUTH URLS */
    static login2fa = () => `${Urls.api}/user/login/2fa/`

    static postTokenRefresh = () => `${Urls.api}/token/refresh/`

    static postTokenPairRefresh: () => string = (): string => `${Urls.api}/token/refresh-pair/`

    static resetPasswordEmail = () => `${Urls.api}/user/reset-password/`

    static resend2fa = () => `${Urls.api}/user/login/2fa/resend-code/`

    /* COACH URLS */
    static getSubUsers = () => `${Urls.api}/user/sub-users/`

    /* COACH CALENDARS */
    static coachCalendarProfiles = () => `${Urls.coachCalendar}/profiles/`

    static coachCalendarAttrs = () => `${Urls.coachCalendar}/oauth-attrs/`

    static setPrimaryCalendar = () => `${Urls.coachCalendar}/profiles/set-primary/`

    static avRulesAttrs = () => `${Urls.coachCalendar}/availability-rules-widget-attrs/`

    static avRules = () => `${Urls.coachCalendar}/availability-rules/`

    static confrimAvRules = () => `${Urls.coachCalendar}/availability-widget-attrs/`

    static confirmSetupCalendar = () => `${Urls.coachCalendar}/confirm-setup/`

    /* PARTICIPANT URLS */
    static postAvailableGuestSessions = ({ swappedSessionId }: { swappedSessionId: number }) =>
        `${Urls.api}/coach-session/${swappedSessionId}/guest/`

    static getSurveyList = () => `${Urls.api}/survey/`

    static profileChange = () => `${Urls.api}/participants/set-personal-info/`

    /* Module Reflection URlS */
    static submitRating = (coachRatingId?: number) =>
        `${Urls.api}/participant-feedback-coach${coachRatingId ? `/${coachRatingId}/` : "/"}`

    static npsQuestion = () => `${Urls.api}/participant-feedback-nps/question/`

    static sendNps = (questionId?: string) =>
        `${Urls.api}/participant-feedback-nps${questionId ? `/${questionId}/` : "/"}`

    /* Onboarding URLS */
    static onboardingWaitListText = () => `${Urls.api}/onboarding/waiting_list/`

    /* Offboarding */
    static offboardingJourneyReflection = () => `${Urls.api}/offboarding/journey-final-questions/`

    static submitOffboardingJourneyReflection = () => `${Urls.api}/offboarding/`

    /* Profile */
    static uploadPhoto = () => `${Urls.api}/user/upload-photo/`

    /* Coaching Plan */
    static coachingGoal = (participantId: number, query: CoachingGoalStatus) =>
        `${Urls.api}/coaching-plan/${participantId}/goal/?status=${query}`

    static createCoachingGoal = participantId => `${Urls.api}/coaching-plan/${participantId}/goal/`

    static editCoachingGoal = (participantId: number, goalId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/goal/${goalId}/`

    static archiveCoachingGoal = (participantId: number, goalId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/goal/${goalId}/archive/`

    static unarchiveCoachingGoal = (participantId: number, goalId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/goal/${goalId}/unarchive/`

    static sortCoachingGoals = (participantId: number) => `${Urls.api}/coaching-plan/${participantId}/goal/sort/`

    /* Behavioral Change */
    static behavioralChange = (participantId: number, query: CoachingGoalStatus) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/?status=${query}`

    static createBehavioralChange = (participantId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/`

    static editBehavioralChange = (participantId: number, behavioralChangeId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/${behavioralChangeId}/`

    static archiveBehavioralChange = (participantId: number, behavioralChangeId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/${behavioralChangeId}/archive/`

    static unarchiveBehavioralChange = (participantId: number, behavioralChangeId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/${behavioralChangeId}/unarchive/`

    static sortBehavioralChange = (participantId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/sort/`

    /* Behavioral Change Practice */
    static behavioralPractice = (participantId: number, behavioralChangeId: number, query: CoachingGoalStatus) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/${behavioralChangeId}/practice/?status=${query}`

    static createBehavioralPractice = (participantId: number, behavioralChangeId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/${behavioralChangeId}/practice/`

    static editBehavioralPractice = (participantId: number, behavioralChangeId: number, practiceId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/${behavioralChangeId}/practice/${practiceId}/`

    static archiveBehavioralPractice = (participantId: number, behavioralChangeId: number, practiceId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/${behavioralChangeId}/practice/${practiceId}/archive/`

    static unarchiveBehavioralPractice = (participantId: number, behavioralChangeId: number, practiceId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/${behavioralChangeId}/practice/${practiceId}/unarchive/`

    static sortBehavioralPractice = (participantId: number, behavioralChangeId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/behavioral-change/${behavioralChangeId}/practice/sort/`

    /* Old belief  */
    static oldBelief = (participantId: number, status: CoachingGoalStatus) =>
        `${Urls.api}/coaching-plan/${participantId}/old-belief/?status=${status}`

    static createOldBelief = (participantId: number) => `${Urls.api}/coaching-plan/${participantId}/old-belief/`

    static editOldBelief = (participantId: number, oldBeliefId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/old-belief/${oldBeliefId}/`

    static archiveOldBelief = (participantId: number, oldBeliefId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/old-belief/${oldBeliefId}/archive/`

    static unarchiveOldBelief = (participantId: number, oldBeliefId: number) =>
        `${Urls.api}/coaching-plan/${participantId}/old-belief/${oldBeliefId}/unarchive/`

    static sortOldBelief = (participantId: number) => `${Urls.api}/coaching-plan/${participantId}/old-belief/sort/`

    /* SimulabUrls */
}

export default Urls
